import clsx from 'clsx';

const Skeleton = ({ className }: { className?: string }) => <div className={clsx('animate-pulse bg-gray-300', className)} />;

export const PlayerDetailsHeroSectionSkeleton = () => {
	return (
		<div className="bg-white w-full h-full my-6 md:h-[420px]">
			<div className="flex flex-col md:flex-row gap-4 items-center justify-between md:gap-20">
				{/* Left: Header + Stats (desktop) */}
				<div className="flex flex-col gap-6 w-full md:w-auto">
					{/* Header */}
					<div className="flex flex-col gap-2 w-fit">
						<div className="flex items-center gap-1">
							<Skeleton className="h-6 w-28" />
							<Skeleton className="h-6 w-14" />
						</div>
						<div className="flex items-center gap-2">
							<Skeleton className="h-12 w-56" />
							<Skeleton className="h-8 w-20 rounded-full" />
						</div>
						<div className="flex items-center gap-2">
							<Skeleton className="size-6 rounded-full" />
							<Skeleton className="h-4 w-24" />
							<Skeleton className="h-4 w-20" />
						</div>
					</div>

					{/* Stats (desktop) */}
					<div className="hidden md:flex flex-col gap-4">
						<Skeleton className="h-14 w-64 rounded-lg" />
						<Skeleton className="h-14 w-64 rounded-lg" />
						<Skeleton className="h-14 w-64 rounded-lg" />
						<div className="flex gap-2">
							{[...Array(5)].map((_, i) => (
								<Skeleton key={i} className="size-9 rounded-full" />
							))}
						</div>
					</div>
				</div>

				{/* Image */}
				<div className="mt-6 md:mt-0 flex items-center justify-center">
					<Skeleton className="size-[200px] md:size-[260px] lg:size-[320px] rounded-full" />
				</div>

				{/* Stats (mobile) */}
				<div className="flex md:hidden flex-col gap-4 w-full">
					<Skeleton className="h-14 w-full rounded-lg" />
					<Skeleton className="h-14 w-full rounded-lg" />
					<Skeleton className="h-14 w-full rounded-lg" />
				</div>

				{/* Teammates */}
				<div className="flex gap-6">
					{[...Array(1)].map((_, teamIdx) => (
						<div key={teamIdx} className="flex flex-col gap-4">
							<Skeleton className="size-[84px] rounded-md" />
							<Skeleton className="h-6 w-28" />
							<div className="flex flex-col gap-3">
								{[...Array(3)].map((__, mateIdx) => (
									<div key={mateIdx} className="flex items-center gap-3">
										<Skeleton className="size-[60px] rounded-full" />
										<div className="flex flex-col gap-1">
											<Skeleton className="h-4 w-24" />
											<Skeleton className="h-4 w-32" />
										</div>
									</div>
								))}
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};
